/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect } from 'react';

export function useClickOutside(
    ref: React.RefObject<HTMLElement>,
    handler: () => void,
    whenActive = true,
    exceptions: React.RefObject<HTMLElement | SVGSVGElement>[] = []
) {
    useEffect(() => {
        if (!whenActive) return undefined;

        const listener = (event: MouseEvent) => {
            const target = event.target as Node;

            if (
                ref.current?.contains(target) ||
                exceptions.some(exRef => exRef.current?.contains(target))
            ) {
                return;
            }

            handler();
        };

        document.addEventListener('mousedown', listener);
        return () => document.removeEventListener('mousedown', listener);
    }, [ref, handler, whenActive, exceptions]);
}
